import React, { FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useEffect, useState } from "preact/hooks";
import SVGIcon from "../SVGIcon";
import cx from "classnames";

interface IValidation {
  errorMessage: string;
}

const ValidationMessage: FunctionComponent<IValidation> = ({ errorMessage }) => {
  return (
    <div>
      <p>{errorMessage}</p>
    </div>
  );
};

export default ValidationMessage;
